<template>
  <div class="dialog-wechat-auto-reply-editor-wrapper">
    <el-dialog width="50%" :title="`添加自动回复消息（${user.username}）`" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form ref="form" :rules="formRule" :model="formData">

        <el-form-item label="回复类型" prop="replyType">
          <el-select v-model="formData.replyType" placeholder="请选择回复类型">
            <el-option label="关注后回复" value="sub" />
            <el-option label="收到消息回复" value="rev" />
            <el-option label="关键词回复" value="key" />
          </el-select>
        </el-form-item>

        <el-form-item label="回复消息" prop="replyMsg">
          <el-button
            size="mini"
            @click="formData.replyMsg.push({ type: 'text', content: '', media_id: '' })">添加回复消息</el-button>
        </el-form-item>
        <div class="reply-msg-list">
          <div class="reply-msg-item"
               v-for="(msg, index) in formData.replyMsg"
               :key="`reply-${index}`">
            <label>回复消息 {{ index + 1 }}</label>

            <el-select
              class="input"
              v-model="formData.replyMsg[index].type"
              placeholder="请选择消息类型">
              <el-option label="文本" value="text" />
              <el-option label="图片" value="image" />
            </el-select>

            <el-input
              class="input"
              placeholder="请输入回复消息"
              v-if="formData.replyMsg[index].type === 'text'"
              v-model="formData.replyMsg[index].content" />

            <el-input
              class="input"
              placeholder="请输入素材 id"
              v-if="formData.replyMsg[index].type === 'image'"
              v-model="formData.replyMsg[index].media_id" />

            <el-button
              size="mini"
              @click="onReplyMsgDeleteClick(index)">删除</el-button>
          </div>
        </div>

        <el-form-item label="关键词" prop="keyWord" v-show="formData.replyType === 'key'">
          <el-button
            size="mini"
            @click="formData.keyWord.push({ key: '', match: 'full' })">添加关键词</el-button>
        </el-form-item>
        <div class="key-word-list" v-show="formData.replyType === 'key'">
          <div class="key-word-item"
               v-for="(keyWord, index) in formData.keyWord"
               :key="`key-word-${index}`">
            <label>关键词 {{ index + 1 }}</label>

            <el-input
              class="input"
              placeholder="请输入关键词"
              v-model="formData.keyWord[index].key" />

            <el-select
              class="input"
              v-model="formData.keyWord[index].match"
              placeholder="请选择关键词匹配模式">
              <el-option label="完全匹配" value="full" />
              <el-option label="模糊匹配" value="regex" />
            </el-select>

            <el-button
              size="mini"
              @click="onKeyWordDeleteClick(index)">删除</el-button>
          </div>
        </div>

      </el-form>

      <div class="submit-box">
        <el-button
          type="danger"
          @click="onFormSubmit">确定</el-button>
        <el-button @click="onFormCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import wechatAutoReplyApi from '@/api/wechatAutoReplyApi'

export default {
  name: 'DialogWechatAutoReplyEditor',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    wechatAccount: {
      type: Object,
      required: true
    },
    wechatAutoReply: {
      type: Object,
      required: false
    },
    mode: {
      type: String,
      required: false,
      default: 'create'
    }
  },
  data () {
    return {
      formData: {
        _id: '',
        userId: '',
        agnetId: '',
        appId: '',
        replyType: 'key',
        replyMsg: [
          {
            type: 'text',
            content: '',
            media_id: ''
          }
        ],
        keyWord: [
          {
            key: '',
            match: 'full'
          }
        ]
      },
      formRule: {
      }
    }
  },
  methods: {
    async onDialogOpen () {
      if (this.mode === 'update') {
        this.formData = {
          _id: this.wechatAutoReply._id,
          userId: this.user.userid,
          agentId: this.user.agents[0].agentid,
          appId: this.wechatAccount.appId,
          replyType: this.wechatAutoReply.reply_type,
          replyMsg: this.wechatAutoReply.reply_msg,
          keyWord: this.wechatAutoReply.key_word
        }
      } else {
        this.formData = {
          _id: '',
          userId: this.user.userid,
          agentId: this.user.agents[0].agentid,
          appId: this.wechatAccount.appId,
          replyType: 'key',
          replyMsg: [
            {
              type: 'text',
              content: '',
              media_id: ''
            }
          ],
          keyWord: [
            {
              key: '',
              match: 'full'
            }
          ]
        }
      }
    },
    onDialogClose () {
      this.$emit('change', false)
      this.$refs['form'].resetFields()
    },

    onReplyMsgDeleteClick (index) {
      if (this.formData.replyMsg.length <= 1) {
        this.$message({
          message: '至少保留一条回复消息',
          type: 'error'
        })
        return
      }
      this.formData.replyMsg.splice(index, 1)
    },
    onKeyWordDeleteClick (index) {
      if (this.formData.keyWord.length <= 1) {
        this.$message({
          message: '至少保留一条关键词',
          type: 'error'
        })
        return
      }
      this.formData.keyWord.splice(index, 1)
    },
    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()

        const cleanData = Object.assign({}, this.formData)
        for (let i = 0; i < cleanData.replyMsg.length; i++) {
          const replyMsg = cleanData.replyMsg[i]
          if (replyMsg.type === 'text') {
            delete cleanData.replyMsg[i].media_id
          } else {
            delete cleanData.replyMsg[i].content
          }
        }
        if (cleanData.replyType !== 'key') {
          cleanData.keyWord = []
        }
        this.$emit('submit', cleanData)
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.onDialogClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wechat-auto-reply-editor-wrapper {

  .reply-msg-list {

    .reply-msg-item {
      display: flex;
      justify-content: start;
      align-items: center;
      margin-left: 30px;
      margin-bottom: 10px;

      .input {
        margin: 0 20px;
        width: 30%;
      }
    }
  }

  .key-word-list {

    .key-word-item {
      display: flex;
      justify-content: start;
      align-items: center;
      margin-left: 30px;
      margin-bottom: 10px;

      .input {
        margin: 0 20px;
        width: 30%;
      }
    }
  }

  .submit-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/user/components/DialogWechatAutoReplyEditor.vue